var _rect, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 32.3",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Cancel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "claimCancelledHWA0",
    x: -895.6,
    y: -303.1,
    width: 1280,
    height: 1040
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m30.8 30.7c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.2 0.5-0.5 0.5zm0-0.9c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.4 0.3-0.1 0.4-0.3v-0.1c-0.1-0.1-0.2-0.3-0.4-0.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "claimCancelledHWA1",
    cx: 15,
    cy: 17.4,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA2",
    d: "m21.9 15h1.6c0.2 0 0.3-0.2 0.3-0.4 0-0.1-0.1-0.2-0.3-0.3h-1.6c-1.1 0-2.1-0.9-2.1-2.1v-1.7c0-0.2-0.1-0.3-0.3-0.3s-0.3 0.1-0.3 0.3v1.6c-0.1 1.6 1.1 2.9 2.7 2.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m21.2 22.4h-6.6c-0.5 0.1-0.9-0.2-1-0.7s0.2-0.9 0.7-1h0.3 6.6c0.5-0.1 0.9 0.2 1 0.7s-0.2 0.9-0.7 1h-0.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m12.9 1.7c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m12.4 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2-0.1 0.2-0.2s-0.1-0.2-0.2-0.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m12.9 0.3c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m13.9 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2-0.1 0.2-0.2s0-0.2-0.2-0.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m33.3 23.9c-0.2 0-0.3 0.2-0.3 0.4v0.7c0 0.2 0.1 0.3 0.3 0.3s0.3-0.2 0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m32.4 23h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3 0.1-0.2-0.1-0.3-0.3-0.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m33.3 21.3c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.4 0.2 0 0.3-0.2 0.3-0.4v-0.8c0-0.1-0.1-0.3-0.3-0.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m35 23h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3s-0.1-0.3-0.3-0.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m2.1 16s0.3 2-2.1 2c0 0 2 0 2 1.9 0.2-1 1-1.8 2.1-1.9 0 0-1.6 0.4-2-2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA4",
    d: "m30.8 2.4s0.3 2-2.1 2c0 0 2 0 2 1.9 0.2-1 1.1-1.7 2.1-1.8 0-0.1-1.6 0.3-2-2.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA4",
    d: "m5.4 27.5c0 0.6-0.4 1-0.9 1.1h-0.2c0.6 0 1 0.4 1 1v0.1c0.1-0.5 0.5-0.9 1.1-1 0-0.1-0.9 0.1-1-1.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA3",
    d: "m5.4 8.1c0 0.3-0.2 0.6-0.5 0.7h-0.2s0.7 0 0.6 0.6c0.1-0.3 0.4-0.6 0.7-0.6 0 0-0.5 0.1-0.6-0.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m23.4 1.5c-0.4 0-0.7-0.2-0.7-0.6s0.2-0.7 0.6-0.7h0.2c0.3 0 0.6 0.3 0.6 0.6 0 0.4-0.3 0.7-0.7 0.7zm0-1c-0.2 0-0.4 0.2-0.4 0.4s0.2 0.4 0.4 0.4 0.4-0.2 0.4-0.4c0.1-0.2-0.1-0.4-0.4-0.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m2.5 4.3c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.2 0.5-0.5 0.5zm0-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3 0.3-0.1 0.3-0.3-0.2-0.3-0.3-0.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA2",
    d: "m35.5 14.1c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.3 0.5-0.5 0.5zm0-0.9c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3 0.3-0.1 0.3-0.3c0-0.1-0.2-0.3-0.3-0.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m22.1 24.4c-0.2-0.3-0.5-0.5-0.9-0.5h-6.6c-0.5-0.1-0.9 0.2-1 0.7s0.2 0.9 0.7 1h0.3 5.8c0.4-0.5 1-0.9 1.7-1.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA1",
    d: "m15.7 9h-3.2c-1 0-1.8 0.8-1.8 1.8v17c0 1 0.8 1.8 1.8 1.8h2.4c-1.3-0.7-2-2.1-2-3.5v-12.8c0-1.9 1.1-3.6 2.8-4.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA2",
    d: "m19.3 29.6h-6.8c-1 0-1.8-0.8-1.8-1.8v-17c0-1 0.8-1.8 1.8-1.8h10.8c1 0 1.8 0.8 1.8 1.8v13.5c0.4 0.1 0.7 0.3 1.1 0.5v-14c0-1.6-1.3-2.9-2.9-2.9h-10.8c-1.6 0-2.9 1.3-2.9 2.8v17c0 1.6 1.3 2.9 2.9 2.9h7.2c-0.2-0.3-0.3-0.6-0.4-1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "claimCancelledHWA5",
    d: "m26.3 26.1c-0.6-0.6-1.5-1-2.4-1-1.9 0-3.5 1.5-3.6 3.5 0 0.9 0.3 1.8 0.9 2.4 0.7 0.7 1.6 1.1 2.5 1.1 1.9 0 3.5-1.6 3.5-3.5 0.1-1-0.3-1.9-0.9-2.5zm0.2 2.5c0 1.5-1.2 2.6-2.6 2.6-0.6 0-1.1-0.2-1.6-0.5l3.7-3.7c0.3 0.5 0.5 1 0.5 1.6zm-2.7-2.6c0.5 0 1 0.2 1.5 0.5l-3.7 3.7c-0.3-0.4-0.5-0.9-0.5-1.5 0.1-1.5 1.3-2.7 2.7-2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCancelled);
export default __webpack_public_path__ + "static/media/claim-cancelled.b1a898626764bc1754c0f63c3ff11a6d.svg";
export { ForwardRef as ReactComponent };